import { useState } from 'react';
import ModalWrapper from '../ModalWrapper';
import Goal from './Goal.png';
import styles from './YourGoalIntro.module.css';
import Button from '../../../shared/ui/button/button';
import { useIntl } from 'react-intl';

const totalSlides = 3;

export function YourGoalIntroContent({ onFinish, onSkip }) {
	const intl = useIntl();
	const [currentSlide] = useState(2);

	return (
		<div className={styles.modalCard}>
			<div className={styles.iconContainer}>
				<img src={Goal} alt='Goal' />
			</div>

			<h1 className={styles.title}>
				{intl.formatMessage({ id: 'YourGoalIntro' })}
			</h1>

			<p className={styles.description}>
				{intl.formatMessage({ id: 'YourGoalIntroId2' })}
			</p>

			<div className={styles.pagination}>
				{Array.from({ length: totalSlides }).map((_, index) => (
					<div
						key={index}
						className={`${styles.dot} ${
							index === currentSlide ? styles.activeDot : ''
						}`}
					/>
				))}
			</div>

			<Button fullWidth onClick={onFinish}>
				{intl.formatMessage({ id: 'YourGoalIntroId3' })}
			</Button>

			<Button variant='ghost' onClick={onSkip}>
				{intl.formatMessage({ id: 'YourGoalIntroId4' })}
			</Button>
		</div>
	);
}

const YourGoalIntro = ({ isOpen, onClose, onFinish }) => {
	const handleSkip = () => {
		if (onClose) onClose();
	};

	if (!isOpen) return null;

	return (
		<ModalWrapper isOpen={isOpen} onSkip={handleSkip}>
			<YourGoalIntroContent onFinish={onFinish} onSkip={handleSkip} />
		</ModalWrapper>
	);
};

export default YourGoalIntro;
